export default __webpack_public_path__ + "static/media/arrow-sider-right.16a16138.svg";